import React, { useEffect, useState } from "react";
import { connect } from 'react-redux';
import stateMap from "store/stateMap";
import BlockHeader from "component/BlockHeader/BlockHeader";
import { useSearchParams, createSearchParams, useNavigate, useLocation, Link } from "react-router-dom";
import Header from "component/Header/Header";
import Footer from "component/Footer/Footer";
import LoginBox from "component/LoginBox/LoginBox";
import EditPageForm from "component/EditPage";
import "./style.scss";
import { PageCredential } from "component/PageCredential";


const PagePagesCreate = (props) => {
    
    let navigate        = useNavigate();

    return (
        <>
            <Header/>
            <PageCredential title={"Create a Page"}/>
                {
                    props.auth.user ?
                    <div className="form-page-basic container w-800 relative">
                        <div className="text-center">
                            <BlockHeader title="Create a Page" desc="" />
                        </div>
                        <EditPageForm onSave={page => {
                            navigate({
                                pathname    : '/group/' + page.PageSlug  
                            });
                        }}/>
                    </div> 
                    : <LoginBox/>
                }
            <Footer/>
        </>
    )
}

export default connect(stateMap)(PagePagesCreate);